import React from "react";
import ApplyFormContainer from "./components/ApplyFormContainer";


function App() {
  return (
    <>
      <ApplyFormContainer />
    </>
  );
}

export default App;
